import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators} from '@angular/forms';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
    selector: 'app-add-edit-role',
    templateUrl: './addeditrole.component.html',
})
export class AddEditRoleComponent implements OnInit {
    submitted: boolean = false;
    role: RoleModel = new RoleModel();
    name = new FormControl('', [Validators.required]);
    description = new FormControl('', [Validators.required]);
    
    constructor(
        public _restAPI: RestAPIService,
        public dialogRef: MatDialogRef<AddEditRoleComponent>,
        @Inject(MAT_DIALOG_DATA) public roleData: RoleModel) {
            this.role = JSON.parse(JSON.stringify(roleData));
            localStorage["applyRoleFilterValue"] = 'true';
        }
    
    async ngOnInit() {
        //init form controls
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }

    async saveRole() {
        if(!this.name.invalid && (this.role.name?.length ?? 0) > 0 && !this.description.invalid){
            if (this.role.id != null && this.role.id.length > 0) {
                let postData = {
                    id: this.role.id,
                    name: this.role.name,
                    description: this.role.description,
                };

                this._restAPI.put<string>(environment.apiURL + 'api/role/edit/' + this.role.id, postData).subscribe({
                    next: (results) => {
                        this.dialogRef.close(true);
                    },
                    error: (error) => console.error(error)
                });
            }
            else {
                let postData = {
                    name: this.role.name,
                    description: this.role.description,
                };

                this._restAPI.post<string>(environment.apiURL + 'api/role/add', postData).subscribe({
                    next: (results) => {
                        this.dialogRef.close(true);
                    },
                    error: (error) => console.error(error)
                });
            }
        }
    }
}
